import React from 'react';
import { Box, Typography, Button, Container, Grid, Chip } from '@mui/material';
import ExploreIcon from '@mui/icons-material/Explore';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { useNavigate } from 'react-router-dom';
import dest1 from '../../assets/destination-card-img/1.jpg';
import dest2 from '../../assets/destination-card-img/2.jpg';
import dest3 from '../../assets/destination-card-img/3.jpg';
import dest4 from '../../assets/destination-card-img/4.jpg';
import dest5 from '../../assets/destination-card-img/5.jpg';
import dest6 from '../../assets/destination-card-img/6.jpg';
import dest7 from '../../assets/destination-card-img/7.jpg';
import dest8 from '../../assets/destination-card-img/8.jpg';
import dest9 from '../../assets/destination-card-img/9.jpg';

const destinations = [
  {
    id: 1,
    name: "Mysore",
    image: dest1,
    tag: "Heritage",
    nights: "1N/2D",
  },
  {
    id: 2,
    name: "Ooty",
    image: dest2,
    tag: "Hill Station",
    nights: "2N/3D",
  },
  {
    id: 3,
    name: "Kodaikanal",
    image: dest3,
    tag: "Nature",
    nights: "2N/3D",
  },
  {
    id: 4,
    name: "Delhi - Agra - Jaipur",
    image: dest4,
    tag: "Historical",
    nights: "4N/5D",
  },
  {
    id: 5,
    name: "Munnar",
    image: dest5,
    tag: "Hill Station",
    nights: "2N/3D",
  },
  {
    id: 6,
    name: "Alleppey",
    image: dest6,
    tag: "Backwaters",
    nights: "1N/2D",
  },
  {
    id: 7,
    name: "Simla - Kullu - Manali Trip",
    image: dest7,
    tag: "Adventure",
    nights: "5N/6D",
  },
  {
    id: 8,
    name: "GOA",
    image: dest8,
    tag: "Beach",
    nights: "3N/4D",
  },
  {
    id: 9,
    name: "Coorg",
    image: dest9,
    tag: "Nature",
    nights: "1N/2D",
  },
];

const DestinationCard = ({ destination }) => (

  <Box
    sx={{
      position: 'relative',
      borderRadius: '6px',
      overflow: 'hidden',
      height: 260,
      cursor: 'pointer',
      '&:hover .card-overlay': {
        background:
          'linear-gradient(to top, rgba(26,74,140,0.92) 0%, rgba(26,74,140,0.4) 50%, transparent 100%)',
      },
      '&:hover img': {
        transform: 'scale(1.07)',
      },
      boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
    }}
  >
    {/* Image */}
    <Box
      component="img"
      src={destination.image}
      alt={destination.name}
      sx={{
        width: '100%',
        height: '100%',
        objectFit: 'fill',
        transition: 'transform 0.5s ease',
      }}
    />

    {/* Top-left badge */}
    <Box
      sx={{
        position: 'absolute',
        top: 12,
        left: 12,
        backgroundColor: '#1a4a8c',
        color: '#fff',
        px: 1.2,
        py: 0.4,
        borderRadius: '3px',
        fontSize: '0.72rem',
        fontWeight: 700,
        letterSpacing: '0.5px',
        zIndex: 2,
      }}
    >
      {destination.tag}
    </Box>

    {/* Top-right badge */}
    <Box
      sx={{
        position: 'absolute',
        top: 12,
        right: 12,
        backgroundColor: '#3eb0e9',
        color: '#fff',
        px: 1.2,
        py: 0.4,
        borderRadius: '3px',
        fontSize: '0.72rem',
        fontWeight: 700,
        zIndex: 2,
      }}
    >
      {destination.nights}
    </Box>

    {/* Bottom overlay */}
    <Box
      className="card-overlay"
      sx={{
        position: 'absolute',
        inset: 0,
        background:
          'linear-gradient(to top, rgba(0,0,0,0.8) 0%, rgba(0,0,0,0.3) 50%, transparent 100%)',
        transition: 'background 0.3s ease',
        zIndex: 1,
      }}
    />

    {/* Bottom text */}
    <Box
      sx={{
        position: 'absolute',
        bottom: 0,
        left: 0,
        right: 0,
        p: 2,
        zIndex: 2,
        display: 'flex',
        alignItems: 'flex-end',
        justifyContent: 'space-between',
      }}
    >
      <Box>
        <Typography
          variant="h6"
          sx={{
            color: '#fff',
            fontWeight: 700,
            fontSize: '1.1rem',
            lineHeight: 1.2,
          }}
        >
          {destination.name}
        </Typography>
        <Typography sx={{ color: '#3eb0e9', fontSize: '0.85rem', fontWeight: 700 }}>
          Starting {destination.price}
        </Typography>
      </Box>
      <Box
        sx={{
          width: 32,
          height: 32,
          borderRadius: '50%',
          backgroundColor: '#3eb0e9',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <ChevronRightIcon sx={{ color: '#fff', fontSize: 20 }} />
      </Box>
    </Box>
  </Box>
);

const DestinationsSection = () => {
  const navigate = useNavigate();
  return (
    <Box sx={{ py: { xs: 5, md: 8 }, backgroundColor: '#f9f9f9' }}>
      <Container maxWidth="xl">
        {/* Section Header */}
        <Box sx={{ textAlign: 'center', mb: 5 }}>
          <Typography
            component="p"
            sx={{
              color: '#3eb0e9',
              fontSize: '0.85rem',
              fontWeight: 700,
              letterSpacing: '2px',
              textTransform: 'uppercase',
              mb: 1,
            }}
          >
            Our Best Packages
          </Typography>
          <Typography
            variant="h3"
            sx={{
              fontFamily: '"Playfair Display", Georgia, serif',
              fontStyle: 'italic',
              color: '#1a4a8c',
              fontSize: { xs: '1.8rem', md: '2.4rem' },
              fontWeight: 700,
              mb: 1.5,
            }}
          >
            Travel Miles With Smiles
          </Typography>
          <Box
            sx={{
              width: 60,
              height: 3,
              backgroundColor: '#3eb0e9',
              margin: '0 auto',
              mb: 2,
              borderRadius: '2px',
            }}
          />
          <Typography
            sx={{
              color: '#888',
              fontStyle: 'italic',
              fontSize: '0.95rem',
              maxWidth: 500,
              mx: 'auto',
            }}
          >
            A Travel without knowledge is like a bird without feather
          </Typography>
        </Box>

        {/* Destinations Grid */}
        <Grid container spacing={3}>
          {destinations.map((dest) => (
            <Grid size={{ xs: 12, sm: 6, md: 4 }} key={dest.id}>
              <DestinationCard destination={dest} />
            </Grid>
          ))}
        </Grid>

        {/* CTA Button */}
        <Box sx={{ textAlign: 'center', mt: 5 }}>
          <Button
            onClick={() => navigate("/about-us")}
            variant="contained"
            size="large"
            endIcon={<ExploreIcon />}
            sx={{
              backgroundColor: '#3eb0e9',
              color: '#fff',
              px: 3,
              py: 0.8,
              fontSize: '0.9rem',
              fontWeight: 700,
              borderRadius: '4px',
              '&:hover': {
                backgroundColor: '#2a90c4',
                transform: 'translateY(-2px)',
                boxShadow: '0 6px 20px rgba(62,176,233,0.4)',
              },
              transition: 'all 0.2s ease',
              boxShadow: '0 4px 15px rgba(62,176,233,0.35)',
            }}
          >
            Explore All Packages
          </Button>
        </Box>
      </Container>
    </Box>
  );
};

export default DestinationsSection;
